module.exports = __webpack_public_path__ + "static/media/hr-1541474986837-2048x2048.1393f659.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/community-gardens/hr-1541474986837-2048x2048.png
// module id = 714
// module chunks = 11